import { render, staticRenderFns } from "./LdpDongHo.vue?vue&type=template&id=023708c6&scoped=true&"
import script from "./LdpDongHo.vue?vue&type=script&lang=js&"
export * from "./LdpDongHo.vue?vue&type=script&lang=js&"
import style0 from "./LdpDongHo.vue?vue&type=style&index=0&id=023708c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023708c6",
  null
  
)

export default component.exports